<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-body">
          <img class="image" :src="imageUrl" />
        </div>
        <div class="modal-footer">
          <div class="image-info">
            {{ status }} {{ $utcToLocal(completedAt, "HH:mm") }}
          </div>
          <div class="close-btn" @click="closeModal">닫기</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style src="./../ModalCommon.css" scoped></style>
<style src="./layout.css" scoped></style>
<script>
/* eslint-disable */
export default {
  components: {},
  watch: {},
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
  },
  data() {
    return {};
  },
  computed: {},
  create() {},
  async mounted() {},
  props: ["imageUrl", "completedAt", "status"],
};
</script>
